import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body7 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '10px', lineHeight: '14px' },
    { fontSize: '12px', lineHeight: '14px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
